import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Editor, Toolbar } from 'ngx-editor';
import { EditorState } from '@codemirror/state';
import { html } from '@codemirror/lang-html';
import { EditorView, ViewPlugin, ViewUpdate } from '@codemirror/view';

@Component({
  selector: 'app-editor-codemirror',
  templateUrl: './editor-codemirror.component.html',
  styleUrls: ['./editor-codemirror.component.scss']
})
export class EditorCodemirrorComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @Input() html: string = '';  // Full HTML content (head + body)
  @Input() editHtml: boolean = false;  // Toggle for HTML editor (CodeMirror)
  @Output() contentUpdated = new EventEmitter<string>();

  @ViewChild('codemirror', { static: true }) codemirrorElement!: ElementRef;
  codemirrorView!: EditorView;
  editor!: Editor;

  public bodyHtml: string = ''; // Editable body content
  private isUpdating = false;

  constructor() {}

  ngOnInit(): void {
    this.editor = new Editor();
    console.log(this.html)
  }

  ngOnChanges(): void {
    if (this.html) {
      this.changeEditor();
    }
  }

  changeEditor() {
    setTimeout(() => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(this.html, 'text/html');
      this.bodyHtml = doc.body.innerHTML;  // Extract only the body content
    })
  }

  ngAfterViewInit(): void {
    // Initialize CodeMirror with the full HTML content
    // this.codemirrorView = new EditorView({
    //   state: EditorState.create({
    //     doc: this.html,  // Initial full HTML (head + body)
    //     extensions: [
    //       html(),
    //       this.syncHtmlWithCodeMirror(),
    //     ]
    //   }),
    //   parent: this.codemirrorElement && this.codemirrorElement.nativeElement
    // });

    // Initialize the bodyHtml content for contenteditable div
    // const parser = new DOMParser();
    // const doc = parser.parseFromString(this.html, 'text/html');
    // this.bodyHtml = doc.body.innerHTML;  // Extract only the body content
  }

  // Synchronize changes from CodeMirror to the shared HTML property
  private syncHtmlWithCodeMirror() {
    const _this = this;
    return ViewPlugin.fromClass(
      class {
        constructor(private view: EditorView) {
          this.updateHtml(view);
        }

        update(update: ViewUpdate) {
          if (update.docChanged && !_this.isUpdating) {
            this.updateHtml(update.view);
          }
        }

        updateHtml(view: EditorView) {
          const newDoc = view.state.doc.toString();
          if (newDoc !== _this.html) {
            _this.isUpdating = true;
            // Update the full HTML content (head + body)
            _this.html = newDoc; 
            _this.bodyHtml = new DOMParser().parseFromString(newDoc, 'text/html').body.innerHTML;
            _this.isUpdating = false;
          }
        }
      }
    );
  }

  // When editor content changes, update the bodyHtml and full HTML
  onEditorChange(event: any): void {
    const newBodyHtml = (event.target as HTMLElement).innerHTML;
    this.bodyHtml = newBodyHtml;
  
    // Create a new DOM element to parse and preserve styles
    const parser = new DOMParser();
    const doc = parser.parseFromString(this.html, 'text/html');
    
    // Grab the current body content from the document
    const bodyElement = doc.body;
  
    // Create a temporary div to hold the new body content
    const newBodyElement = document.createElement('div');
    newBodyElement.innerHTML = newBodyHtml;
  
    // Get all child elements of the new body
    const newElements = Array.from(newBodyElement.querySelectorAll('*'));
    const originalElements = Array.from(bodyElement.querySelectorAll('*'));
  
    // Loop through all elements inside the new content and restore inline styles
    newElements.forEach((newElement, index) => {
      const originalElement = originalElements[index];
  
      if (originalElement) {
        // Copy inline styles from the original to the new element
        const style = originalElement.getAttribute('style');
        if (style) {
          newElement.setAttribute('style', style); // Copy inline styles
        }
  
        // Preserve other attributes like class, id, etc.
        newElement.setAttribute('class', originalElement.getAttribute('class') || '');
        newElement.setAttribute('id', originalElement.getAttribute('id') || '');
        // Add other attributes as needed (e.g., data attributes, etc.)
      }
    });
  
    // Replace the body with the updated content
    bodyElement.innerHTML = newBodyElement.innerHTML;
  
    // Update the full HTML document with the updated body content
    this.html = doc.documentElement.outerHTML;
  
    this.contentUpdated.emit(this.html); // Emit the updated content
  
    // Update CodeMirror content (without triggering endless loop)
    if (this.codemirrorView && !this.isUpdating) {
      this.isUpdating = true;
      this.codemirrorView.dispatch({
        changes: { from: 0, to: this.codemirrorView.state.doc.length, insert: this.html }
      });
      this.isUpdating = false;
    }
  }
  
  
  

  ngOnDestroy(): void {
    this.editor.destroy(); // Clean up the editor when the component is destroyed
  }
}
